var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2723 19.0907V17.1817C16.2723 16.169 15.87 15.1979 15.154 14.4819C14.438 13.7658 13.4668 13.3636 12.4542 13.3636H4.81808C3.80546 13.3636 2.83432 13.7658 2.11829 14.4819C1.40226 15.1979 1 16.169 1 17.1817V19.0907",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63644 9.54552C10.7451 9.54552 12.4545 7.8361 12.4545 5.72744C12.4545 3.61877 10.7451 1.90936 8.63644 1.90936C6.52777 1.90936 4.81836 3.61877 4.81836 5.72744C4.81836 7.8361 6.52777 9.54552 8.63644 9.54552Z",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9983 19.0905V17.1815C21.9977 16.3355 21.7161 15.5137 21.1978 14.8451C20.6795 14.1765 19.9539 13.699 19.1348 13.4875",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3184 2.03333C16.1396 2.24361 16.8676 2.72125 17.3874 3.39095C17.9072 4.06065 18.1894 4.88431 18.1894 5.73209C18.1894 6.57986 17.9072 7.40353 17.3874 8.07323C16.8676 8.74293 16.1396 9.22057 15.3184 9.43085",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.35a55fe06534a7152608a5afcfffe9f9.svg";
export { ForwardRef as ReactComponent };